import { global } from "../constants";

export const data = {
    banner: {
        background: global.banner + "1.jpg",
        title: "Blog Grid",
        crumb: "Blog Grid"
    },

    blogs: [
        {
            image: global.blog1 + "bg1.jpg",
            day: "02",
            month: "Aug",
            title: "At the end of the day, going forward, a new normal that has evolved from.",
            description: "New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit."
        },
        {
            image: global.blog2 + "l-1.jpg",
            day: "08",
            month: "Aug",
            title: "How all this mistaken idea of denouncing pleasure and praising pain was.",
            description: "New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit."
        },
        {
            image: global.blog1 + "bg2.jpg",
            day: "21",
            month: "Aug",
            title: "Going forward, a new normal that has evolved from generation.",
            description: "New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit."
        },
        {
            image: global.blog2 + "l-2.jpg",
            day: "02",
            month: "Aug",
            title: "At the end of the day, going forward, a new normal that has evolved from.",
            description: "New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit."
        },
        {
            image: global.blog1 + "bg3.jpg",
            day: "08",
            month: "Aug",
            title: "How all this mistaken idea denouncing pleasure and praising pain was.",
            description: "New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit."
        },
        {
            image: global.blog2 + "l-3.jpg",
            day: "21",
            month: "Aug",
            title: "Going forward, a new normal that has evolved from generation.",
            description: "New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit."
        },
        {
            image: "",
            day: "02",
            month: "Aug",
            title: "Go beyond logistics, make the world go round and revolutionize",
            description: "New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit."
        }
    ]
}